export default {
  GET_PAYMENT_HISTORY_PAGE: {
    url: '/transaction/page',
    method: 'GET'
  }
};
